/**
 * Per-session module caches, cleared together when the user signs out.
 *
 * Logging out navigates inside the SPA, so module-level caches (capabilities, effective
 * permissions, org settings, catalogues) outlive the session. Without this, the next user to sign
 * in on the same tab sees the previous user's sidebar and screens until each cache goes stale.
 * Any module that caches user- or tenant-specific data registers its reset here.
 */
const resetters = new Set<() => void>();

/** Bumped on every reset, so an in-flight request from the old session can tell it is stale. */
let generation = 0;

export const sessionGeneration = (): number => generation;

export const registerSessionCache = (reset: () => void): void => {
  resetters.add(reset);
};

export const resetSessionCaches = (): void => {
  generation += 1;
  resetters.forEach((reset) => {
    try {
      reset();
    } catch {
      /* one broken reset must not keep the rest */
    }
  });
};
